import { connect } from 'react-redux';
import {
  closeConfirmLeaveModal,
  openConfirmLeaveModal,
  updateOpenModalBeforeLeave,
  updatePageLoading,
} from '../../../actions/ui';
import { loadFormData, loadForm, removeFormAndFormData } from '../../../actions/externalForm';
import { loadTransaction, removeTransaction } from '../../../actions/transaction';
import Iframes from './Iframes';

const mapStateToProps = state => ({
  catalog: state.catalog,
  ui: state.ui,
  transaction: state.transaction,
  pageLoading: state.ui.pageLoading,
  user: state.user,
  externalForm: state.externalForm,
});

const mapDispatchToProps = {
  openConfirmLeaveModal,
  loadFormData,
  loadForm,
  removeFormAndFormData,
  closeConfirmLeaveModal,
  loadTransaction,
  removeTransaction,
  updateOpenModalBeforeLeave,
  updatePageLoading,
};

const IframesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Iframes);

export default IframesContainer;
